import Login from './Login'
import ResetPassword from './ResetPassword'

const Form = { Login, ResetPassword }

export default Form
